import { LoyaltyAcmService } from './../../../../services/loyalty/loyalty-acm.service';
import { SelectItem } from 'primeng/primeng';
import { Validators } from '@angular/forms';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { debug } from 'console';

@Component({
  selector: 'app-campaign-accumulators-form',
  templateUrl: './campaign-accumulators-form.component.html',
  styleUrls: ['./campaign-accumulators-form.component.css']
})
export class CampaignAccumulatorsFormComponent implements OnInit {
  acmForm: FormGroup;
  invalidSubmit = false;
  acmList: SelectItem[] = [];
  acmFieldDisabled = true;
  @Input() messageInstance: any;
  @Input() acm: any;
  @Input() channelList: SelectItem[];
  @Input() acmTypeList: SelectItem[];
  @Input() operationTypeList: SelectItem[];
  @Input() acmScopeList: SelectItem[];
  @Input() actionStartDate: string;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  operationTypeElement: SelectItem[] = [];

  constructor(
    private fb: FormBuilder,
    private loyaltyAcmService: LoyaltyAcmService
  ) { }

  ngOnInit() {
    this.acmForm = this.fb.group({
      channelCode: !!this.acm ? [this.acm.loyalty_channel_id, Validators.required] : ['', Validators.required],
      acmType: !!this.acm ? [this.acm.acm_type_code, Validators.required] : ['', Validators.required],
      acm: !!this.acm ? [this.acm.acm_id] : ['', Validators.required],
      acmName: !!this.acm ? [this.acm.acm_name] : [''],
      dateStart: !!this.acm ? [this.acm.acm_date_start] : [''],
      dateEnd: !!this.acm ? [this.acm.acm_date_end] : [''],
      acmCode: !!this.acm ? [this.acm.acm_code] : [''],
      operationType: !!this.acm ? [this.acm.operation_type] : [''],
      value: !!this.acm ? [this.acm.value] : [''],
      exp: !!this.acm ? [this.acm.control_exp] : [''],
      scope: !!this.acm ? [this.acm.acm_scope] : ['']
    });
    this.operationTypeElement = this.operationTypeList[0].value;
  }

  getAcmList() {
    const channel = this.acmForm.get('channelCode').value;
    const acmType = this.acmForm.get('acmType').value;
    if (!!channel && !!acmType) {
      if (this.acmFieldDisabled) {
        this.acmFieldDisabled = false;
      }
      const searchParams = [
        {key: "date_start", value: this.actionStartDate},
        {key: "date_end", value: this.actionStartDate},
        {key: "acmTypeCode", value: acmType},
        {key: "channel_id", value: channel},
        {key: "acmVisible", value: '0'}
      ];
      if (this.messageInstance.end_fruition_date) {
        searchParams.push({key: "date_end", value: this.messageInstance.end_fruition_date});
      }
      this.loyaltyAcmService.getAllAcm(searchParams).subscribe(res => {
        res.forEach(acm => this.acmList.push({label: acm.acmDescription, value: acm}));
      });
    } else if (!this.acmFieldDisabled) {
      this.acmFieldDisabled = true;
    }
  }

  setAcmData(acm: any) {
    this.acmForm.get('dateStart').setValue(acm.dateStart);
    this.acmForm.get('dateEnd').setValue(acm.dateEnd);
    this.acmForm.get('acmCode').setValue(acm.acm_code);
  }

  save() {
    if (!this.acmForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const acmData = {
      message_instance_id: this.messageInstance.id,
      loyalty_channel_id: this.acmForm.get('channelCode').value,
      acm_id: !!this.acm ? this.acmForm.get('acm').value : this.acmForm.get('acm').value.id,
      operation_type: this.acmForm.get('operationType').value==""?this.operationTypeElement[0].value:this.acmForm.get('operationType').value,
      control_exp: this.acmForm.get('exp').value,
      value: this.acmForm.get('value').value !="" ? this.acmForm.get('value').value: null,
      acm_scope: this.acmForm.get('scope').value!="" ? this.acmForm.get('scope').value: null
    }
    this.onSave.emit(acmData);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-accumulators/campaign-accumulators-form/campaign-accumulators-form.component.ts